export class InstitEvolucaoFiltrosDTO {    
    mes:string;
    cdsAreasGeo: string[];
    tipoPaciente: string;
}